import { render, staticRenderFns } from "./TestStudentModal.vue?vue&type=template&id=de62d218&scoped=true&"
import script from "./TestStudentModal.vue?vue&type=script&lang=js&"
export * from "./TestStudentModal.vue?vue&type=script&lang=js&"
import style0 from "./TestStudentModal.vue?vue&type=style&index=0&id=de62d218&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de62d218",
  null
  
)

export default component.exports